import { render, staticRenderFns } from "./ContLineageIframes.vue?vue&type=template&id=84c73860&scoped=true&lang=pug"
import script from "./ContLineageIframes.vue?vue&type=script&lang=js"
export * from "./ContLineageIframes.vue?vue&type=script&lang=js"
import style0 from "./ContLineageIframes.vue?vue&type=style&index=0&id=84c73860&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c73860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c73860')) {
      api.createRecord('84c73860', component.options)
    } else {
      api.reload('84c73860', component.options)
    }
    module.hot.accept("./ContLineageIframes.vue?vue&type=template&id=84c73860&scoped=true&lang=pug", function () {
      api.rerender('84c73860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ContLineageIframes.vue"
export default component.exports